export default __webpack_public_path__ + "files/c287f446dbba07683995cd08ef81c911.mp3";